import { Input, InputProps } from '@progress/kendo-react-inputs';
import { Error } from '@progress/kendo-react-labels';
import { useEffect } from 'react';
import { useEntidadeStore } from '../../../stores/entidade';
import type { FieldRenderProps } from '@progress/kendo-react-form';

const validateField = (value: string | null | undefined, type: string): string => {
  switch (type) {
    case 'email': {
      if (!value) {
        return ''; 
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return !emailRegex.test(value) ? 'Introduza um email válido.' : '';
    }
    default: {
      return !value || value.trim() === '' ? 'Campo obrigatório.' : '';
    }
  }
};

export default function ValidatedIdentificacaoInput(
  fieldRenderProps: FieldRenderProps
) {
  const setIsIdentificacaoTabValid = useEntidadeStore(
    (state) => state.setIsIdentificacaoTabValid
  );
  const addIdentificacaoTabValidatedField = useEntidadeStore(
    (state) => state.addIdentificacaoTabValidatedField
  );

  const validationMessage = validateField(fieldRenderProps.value, fieldRenderProps.name);

  useEffect(() => {
    const isValid =
      fieldRenderProps.name === 'email'
        ? !fieldRenderProps.value || !validationMessage 
        : !!fieldRenderProps.value && !validationMessage;

    setIsIdentificacaoTabValid(isValid);
    addIdentificacaoTabValidatedField({
      [fieldRenderProps.name]: isValid,
    });
  }, [fieldRenderProps.value, validationMessage]);

  return (
    <div>
      <Input {...(fieldRenderProps as InputProps)} />
      {fieldRenderProps.visited && validationMessage && (
        <Error>{validationMessage}</Error>
      )}
    </div>
  );
}
